<template>
  <v-dialog v-model="dialog" width="500">
    <div class="card card--white">
      <div class="card--container">
        <h3>Choose a New Habit Program</h3>
        <v-radio-group v-model="selectedProgram" style="max-height: 200px; overflow-y: scroll">
          <v-radio
            v-for="habitProgram in habitPrograms"
            :key="habitProgram.id"
            :label="habitProgram.name"
            :value="habitProgram.id"
          ></v-radio>
        </v-radio-group>
        <h-btn color="primary" :flat="true" @click="save">Save</h-btn>
        <h-btn :flat="true" @click="dialog=false">Cancel</h-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import dataStore from "@/services/api/store";
import snackbar from "@/services/hubs/snackbar";
import axios from "axios";

export default {
  props: ["display", "userId"],
  data() {
    return {
      dialog: false,
      habitPrograms: [],
      selectedProgram: undefined
    };
  },
  created() {
    dataStore
      .findAll("CoachHabitPrograms", { deleted: false }, { force: true })
      .then(habitPrograms => {
        this.habitPrograms = habitPrograms;
      });
  },
  methods: {
    save() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}user/${
            this.userId
          }/change_habit_program/`,
          { habit_program: this.selectedProgram }
        )
        .then(() => {
          snackbar.update("Saved");
          this.dialog = false;
        });
    }
  },
  watch: {
    display(newValue) {
      if (newValue) {
        this.dialog = true;
      }
    },
    dialog(newValue) {
      if (!newValue) {
        this.$emit("closed");
      }
    }
  }
};
</script>
